import EventModel from '@/common/models/rules/event-model';

export default {
    props: {
        action: Object,
        event: {
            type: EventModel,
        },
    },
};
